import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimplePaginatorComponent } from './simple-paginator.component';

@NgModule({
  declarations: [SimplePaginatorComponent],
  imports: [CommonModule],
  exports: [SimplePaginatorComponent]
})
export class SimplePaginatorModule {}
